import { render, staticRenderFns } from "./ComplaintListPage.vue?vue&type=template&id=5e42e64d&scoped=true"
import script from "./ComplaintListPage.vue?vue&type=script&lang=js"
export * from "./ComplaintListPage.vue?vue&type=script&lang=js"
import style0 from "./ComplaintListPage.vue?vue&type=style&index=0&id=5e42e64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42e64d",
  null
  
)

export default component.exports